import { HStack, VStack, View } from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";
import { Text } from "@repo/core/components/core/Text";

import { SendToCreditTableController } from "./controller";

import { SelectControlled } from "@repo/core/components/forms/SelectControlled";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { reasonOptions } from "@repo/core/screens/CreditTable/screens/SendToCreditTable/consts";
import { TextAreaControlled } from "@repo/core/components/forms/TextAreaControlled";

export const SendToCreditTable = () => {
  const {
    control,
    isValid,
    back,
    isTabletOrWeb,
    isSubmitting,
    isMobile,
    handleOnSubmitForm
  } = SendToCreditTableController();
  return (
    <>
      <Scaffolds.Root
        minHeight="$100vh"
        showHeader={false}
        statusBarVariant={StatusBarVariantEnum.GREEN}
      >
        <Scaffolds.Form
          showHeader
          title="Enviar para Mesa de Crédito"
          onBackPress={back}
          footerContent={
            <VStack
              gap="$4"
              pb="$4"
              px={isMobile ? "$4" : "$0"}
              flexDirection={isTabletOrWeb ? "row-reverse" : "column"}
              justifyContent={isTabletOrWeb ? "center" : "center"}
              w={isTabletOrWeb ? 480 : "$full"}
              m={isTabletOrWeb ? "auto" : undefined}
            >
              <Button
                size="xl"
                isDisabled={!isValid}
                isLoading={isSubmitting}
                action={isValid ? "primary" : "secondary"}
                text="Enviar"
                w={isTabletOrWeb ? "$1/2" : "$full"}
                onPress={handleOnSubmitForm}
              />
              <Button
                isDisabled={isSubmitting}
                variant="outline"
                action="negative"
                size="xl"
                w={isTabletOrWeb ? "$1/2" : "$full"}
                text="Cancelar"
                onPress={back}
              />
            </VStack>
          }
        >
          <VStack flex={1} px="$4">
            <HStack alignItems="center" justifyContent="center">
              <Text fontSize="$md" fontWeight={400} color="$textLight800">
                Apresente o motivo do envio para a mesa de crédito:
              </Text>
            </HStack>

            <View
              flexGrow={1}
              gap="$4"
              pt="$6"
              w={isTabletOrWeb ? 480 : "$full"}
              m={isTabletOrWeb ? "auto" : undefined}
            >
              <SelectControlled
                control={control}
                name="reason"
                placeholder="Selecione o motivo"
                label="Motivo"
                options={reasonOptions}
                isRequired
              />

              <TextAreaControlled
                control={control}
                name="observations"
                placeholder="Escreva suas observações (opcional)"
                size="md"
                label="Observações"
                maxLength={100}
                helperText="Limite de 100 caracteres."
              />
            </View>
          </VStack>
        </Scaffolds.Form>
      </Scaffolds.Root>
    </>
  );
};
